export default __webpack_public_path__ + "static/media/wi_5.40e9f946.mp3";